import React, { useRef } from 'react'

function Modal({ title, onSave, modalId = "myModal", modalSize="lg", modalPosition="centered", children }) {
    const closeButtonRef = useRef(null);
    const handleSubmit = async (e) => {
        e.preventDefault();  
       await onSave(e); 

       if (closeButtonRef.current) {
            closeButtonRef.current.click();
        }
    };


    return (
        <>
        <div className="modal fade" id={modalId} tabindex="-1" role="dialog">
        <div className={`modal-dialog modal-dialog-${modalPosition} modal-${modalSize}`} role="document">
            <div className="modal-content">
                <div className="modal-header">
                <h5 className="modal-title">{title}</h5>
                <button className="btn-close"  ref={closeButtonRef} type="button" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <form onSubmit={handleSubmit} className='needs-validation' encType="multipart/form-data">
                    <div className="modal-body">
                        {children}
                    </div>
                    <div className="modal-footer">
                    <button className="btn btn-secondary" type="button" data-bs-dismiss="modal">Close</button>
                    <button className="btn btn-primary" type="submit">Save changes</button>
                    </div>
                </form>
            </div>
            </div>
        </div>
        </>
    )
}

export default Modal
